import React from 'react'
import { Tooltip as ChakraTooltip } from '@chakra-ui/react'

const Tooltip = ({...rest}) => {
    return(
        <ChakraTooltip bg="gray.500" placement="left" hasArrow {...rest} />
    )
}

export { Tooltip }